import React, { useEffect, useState } from "react";


const Targets = () => {

  const [counters, setCounters] = useState([
    { id: 1, value: 0, target: 107, title: "Experienced Consultants", icon: "fas fa-users" },
    { id: 2, value: 0, target: 2000, title: "Successful Projects", icon: "fas fa-laptop" },
    { id: 3, value: 0, target: 47, title: "Winning Awards", icon: "fas fa-award" },
    { id: 4, value: 0, target: 100, title: "Satisfied Customers", icon: "fas fa-user", suffix: "%" },
  ]);
  useEffect(() => {
    // Animate counter values
    const duration = 3000; // 3 seconds
    const steps = 50; // Number of animation steps
    const interval = duration / steps; // Time per step
  
    counters.forEach((counter, index) => {
      let stepValue = counter.target / steps;
      let count = 0;
  
      const timer = setInterval(() => {
        count += stepValue;
        if (count >= counter.target) {
          count = counter.target;
          clearInterval(timer);
        }
        setCounters((prev) =>
          prev.map((c) => (c.id === counter.id ? { ...c, value: Math.floor(count) } : c))
        );
      }, interval);
    });
  }, []);

  return (
    <div id="Targets">
      {/* <section
        className="fact-counter sec-padd"
        style={{
          backgroundImage:
            'url(https://st.ourhtmldemo.com/new/experts_html/images/background/4.jpg)',
        }}
      >
        <div className="container">
          <div className="row clearfix">
            <div className="counter-outer clearfix" style={{ display: 'flex' }}>
              {/* Column 1 */}
              {/* <article
                className="column counter-column col-md-3 col-sm-6 col-xs-12 wow fadeIn animated counted"
                data-wow-duration="0ms"
                style={{
                  visibility: 'visible',
                  animationDuration: '0ms',
                  animationName: 'fadeIn',
                }}
              >
                <div className="item">
                  <div className="count-outer">
                    <span className="count-text" data-speed="3000" data-stop="107">
                      107
                    </span>
                  </div>
                  <h4 className="counter-title">Experienced Consultants</h4>
                  <div className="icon">
                    <i className="fas fa-users"></i>
                  </div>
                </div>
              </article>

              {/* Column 2 */}
              {/* <article
                className="column counter-column col-md-3 col-sm-6 col-xs-12 wow fadeIn animated counted"
                data-wow-duration="0ms"
                style={{
                  visibility: 'visible',
                  animationDuration: '0ms',
                  animationName: 'fadeIn',
                }}
              >
                <div className="item">
                  <div className="count-outer">
                    <span className="count-text" data-speed="3000" data-stop="2000">
                      2000
                    </span>
                  </div>
                  <h4 className="counter-title">Successful Resources</h4>
                  <div className="icon">
                    <i className="fas fa-laptop"></i>
                  </div>
                </div>
              </article> */}

              {/* Column 3 */}
              {/* <article
                className="column counter-column col-md-3 col-sm-6 col-xs-12 wow fadeIn animated counted"
                data-wow-duration="0ms"
                style={{
                  visibility: 'visible',
                  animationDuration: '0ms',
                  animationName: 'fadeIn',
                }}
              >
                <div className="item">
                  <div className="count-outer">
                    <span className="count-text" data-speed="3000" data-stop="47">
                      47
                    </span>
                  </div>
                  <h4 className="counter-title">Proven Success Stories </h4>
                  <div className="icon">
                    <i className="fas fa-award"></i>
                  </div>
                </div>
              </article> */}

              {/* Column 4 */}
              {/* <article
                className="column counter-column col-md-3 col-sm-6 col-xs-12 wow fadeIn animated counted"
                data-wow-duration="0ms"
                style={{
                  visibility: 'visible',
                  animationDuration: '0ms',
                  animationName: 'fadeIn',
                }}
              >
                <div className="item">
                  <div className="count-outer">
                    <span className="count-text" data-speed="3000" data-stop="100">
                      100
                    </span>
                    <span>%</span>
                  </div>
                  <h4 className="counter-title">Satisfied Customers</h4>
                  <div className="icon">
                    <i className="fas fa-user"></i>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>  */} 

<section
      className="fact-counter sec-padd"
      style={{ backgroundImage: "url(https://st.ourhtmldemo.com/new/experts_html/images/background/4.jpg)" }}
    >
      <div className="container">
        <div className="row clearfix">
          {counters.map((counter) => (
            <div
              key={counter.id}
              className="column counter-column col-md-3 col-sm-6 col-12 wow fadeIn animated counted"
              data-wow-duration="0ms"
              style={{ visibility: "visible", animationDuration: "0ms", animationName: "fadeIn" }}
            >
              <div className="item">
                <div className="count-outer">
                  <span className="count-text">{counter.value}</span>
                  {counter.suffix && counter.suffix}
                </div>
                <h4 className="counter-title">{counter.title}</h4>
                <div className="icon">
                  <i className={counter.icon}></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
   
    </div>
  );
};

export default Targets;
